import { useCount } from "@/global-state/global.state";
import { pages } from "@/services/requests";
import { ICampaignDetail, IRelateds } from "global-types/global.types";
import { SetStateAction } from "react";
import { useQuery } from "react-query";

interface Props {
  id: string | number;
  initialData?: ICampaignDetail;
  setPaginationData: (
    value: SetStateAction<IRelateds[]>
  ) => void;
  params?: {
    page?: number;
  };
}

export default function useCampaignDetail({ id, initialData, setPaginationData, params }: Props) {
  const { count } = useCount();

  const { data, isLoading, isFetching } = useQuery(
    ["CAMPAIGN_DETAIL", id, params], 
    () => pages.campaignDetail(id, params?.page || 1),
    {
      initialData: initialData,
      enabled: !!id,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: (data) => {
        if (count === 1) {
          setPaginationData(data.data.products.data);
        } else {
          setPaginationData((prev) => [...prev, ...data.data.products.data]);
        }
      },
    }
  );

  return { data, isLoading, isFetching };
}
